export default {
  check_status: {
    verified: 'Verified',
    pending: 'Pending',
    failed: 'Failed',
    not_applicable: 'Not needed',
    required: 'Required',
  },
  records: {
    type: 'Type',
    name: 'Name',
    value: 'Value',
    status: 'Status',
    certificate: 'Certificate',
    certificate_hint: 'Issued automatically once the records above are found.',
    full_name: 'Full name:',
  },
  check_hint: {
    found: 'Found {{values}} instead. Replace it with the value shown.',
    missing: 'This record could not be found.',
    certificate: 'The certificate could not be issued. Fix the records marked above, then check again.',
    certificate_unknown:
      'The certificate could not be issued. Check again later, and contact support if it stays like this.',
    regressed: 'This record was verified before and is no longer found.',
    technical: 'Technical detail: {{error}}',
    held_by_another_project:
      '{{name}} is used by another website on Vercel, so it cannot forward visitors to the shop on www.{{name}}. For {{name}} to open the shop too, remove the domain from that other website first.',
    certificate_pending: {
      not_attached: 'In progress: the domain is being added on our side.',
      awaiting_dns: 'In progress: the certificate is issued once the records above are found.',
      awaiting_certificate:
        'In progress: the records point to us, and the certificate is being issued. This usually takes a few minutes.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} is also connected to another Vercel account. To prove it is yours, add the TXT records below at the DNS provider as well, then check again.',
      held_by_another_project:
        'Another website on Vercel already uses {{name}}. Remove the domain from that website first, then check again — or use another domain.',
      dns_correct_but_unconfigured:
        'The records above are right, but something else on {{name}} blocks the certificate. Remove any AAAA record on it, turn off any proxy in front of it (such as the orange cloud on Cloudflare), and make sure no CAA record rules out Let’s Encrypt. Then check again.',
      name_mismatch:
        '{{name}} answers with a certificate for {{names}}. Make sure the records above are the only ones on {{name}}; if they are, contact support.',
      name_mismatch_unnamed:
        '{{name}} answers with a certificate for another name. Make sure the records above are the only ones on {{name}}; if they are, contact support.',
      expired:
        'The certificate has expired and was not renewed. We have been alerted and are on it — nothing to do for now.',
      expiring: 'The certificate expires soon and has not been renewed yet. We are on it — nothing to do for now.',
      attach_refused:
        'Our hosting provider refused to add {{name}} on our side. We have been alerted and are looking into it — nothing to change at the DNS provider for now.',
    },
    certificate_overdue: {
      not_attached: 'After 48 hours, the domain still could not be added on our side. Contact support.',
      awaiting_dns:
        'Still waiting for the records above after 48 hours. Fix the records marked above, then check again.',
      awaiting_dns_records_verified:
        'Still not issued after 48 hours, although the records above are verified. Contact support.',
      awaiting_certificate:
        'The records point to us, but the certificate has still not been issued after 48 hours. Contact support.',
    },
    certificate_dates: {
      valid_until: 'Valid until {{date}}.',
      expires_on: 'Expires on {{date}}.',
      expired_on: 'Expired on {{date}}.',
    },
  },
};
